import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#C7D0D9"
      d="M101.5 80.36c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path
      fill="#ACB8C3"
      d="M78.39 13.76a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M13.88 60.3a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#C7D0D9"
      d="m18.1 89.62 3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM99.16 45.06h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M58 88.64c6.153 0 11.14-4.987 11.14-11.14 0-6.152-4.987-11.14-11.14-11.14S46.86 71.348 46.86 77.5 51.847 88.64 58 88.64"
    />
    <path
      fill="#ACB8C3"
      d="M80.21 64.05c-1.43-8.15.42-15.29-2.65-23.22C71.96 26.37 58 27.38 58 27.38s-13.96-1.02-19.56 13.45c-3.07 7.93-1.22 15.07-2.65 23.22-.59 3.38-1.67 6.03-2.74 7.97-1.01 1.83.32 4.05 2.4 4.05h45.09c2.09 0 3.41-2.23 2.4-4.05-1.07-1.94-2.15-4.58-2.74-7.97z"
    />
    <path
      fill="#C7D0D9"
      d="M70.72 46.88c-.9 0-1.75-.55-2.1-1.44-3.01-7.77-10.39-7.32-10.46-7.32a2.251 2.251 0 1 1-.33-4.49c3.71-.27 11.63 1.51 14.99 10.18a2.25 2.25 0 0 1-2.1 3.06zM38.36 44.74c6.683 0 12.1-5.417 12.1-12.1s-5.417-12.1-12.1-12.1-12.1 5.417-12.1 12.1 5.417 12.1 12.1 12.1"
    />
    <path
      fill="#7B8493"
      d="M37.99 32.64c0 .51-.42.93-.93.93h-1.72v1.61c0 .54-.44.98-.98.98s-.98-.44-.98-.98v-1.61h-1.71c-.51 0-.93-.42-.93-.93s.42-.93.93-.93h1.71V30.1c0-.54.44-.98.98-.98s.98.44.98.98v1.61h1.72c.51 0 .93.42.93.93M40.88 37.98v-6.75h-2.26v-1.99c2.12 0 2.59-.61 2.59-1.93h2.2v10.68h-2.53z"
    />
  </svg>
);
const SvgEnrichedIconNotificationsGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconNotificationsGreyscale);
export default Memo;
